module.exports = __webpack_public_path__ + "img/chart.841df37d.svg";